<div class="req-modal">

  <!-- HEADER -->
  <div class="req-header">

    <div class="header-content">

      <div class="header-icon">

        <mat-icon>
          description
        </mat-icon>

      </div>

      <div>

        <h2>Create Requisition</h2>

        <p>
          Search existing patient or onboard a new patient
        </p>

      </div>

    </div>

    <button class="close-btn" (click)="close()">

      <mat-icon>
        close
      </mat-icon>

    </button>

  </div>

  <!-- SEARCH -->
  <div class="req-search-section">

    <div class="req-search-box">

      <mat-icon class="search-icon">
        search
      </mat-icon>

      <input type="text" placeholder="Search by Name, Mobile Number or UHID..." [(ngModel)]="searchString"
        (keyup)="onSearchKeyup()">

    </div>

    <button class="new-patient-btn" (click)="openPatientOnboard()">

      <mat-icon>person_add</mat-icon>
      New Patient
    </button>
  </div>
  <!-- LOADING -->
  <div class="loading-box" *ngIf="showLoading">

    Searching Patients...

  </div>

  <!-- RESULTS -->
  <div class="patient-results" *ngIf="!showLoading && searchPatientData.length > 0">

    <div class="patient-card" *ngFor="let patient of searchPatientData">

      <div class="patient-left">

        <div class="avatar">
          {{ patient.firstName?.charAt(0) || 'P' }}
        </div>

        <div class="patient-info">

          <div class="patient-name">
            {{ patient.firstName }}
            {{ patient.middleName }}
            {{ patient.lastName }}
          </div>

          <div class="patient-meta">
            {{ patient.gender || '-' }}
            |
            {{ patient.contactNo || '-' }}
          </div>

          <div class="patient-id">
            UHID : {{ patient.userId || '-' }}
          </div>

        </div>

      </div>

      <button class="select-btn" (click)="selectPatientForRequisition(patient)">

        <mat-icon>description</mat-icon>
        Create Requisition
      </button>
    </div>
  </div>

  <!-- NO DATA -->
  <div class="empty-state" *ngIf="
      !showLoading &&
      hasSearched &&
      searchPatientData.length === 0">

    <mat-icon>search_off</mat-icon>

    <h3>No Patients Found</h3>

    <p>
      Search patient using Name, Mobile Number or UHID
    </p>

  </div>

</div>